"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigint = void 0;
var bigint_1 = require("./bigint");
Object.defineProperty(exports, "bigint", { enumerable: true, get: function () { return bigint_1.bigint; } });
